import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { test } from "redux-store/lab-tests/tests.selecter";
import { useDispatch, useSelector } from "react-redux";
type Props = {
  onClose: () => void;
  open: boolean;
  user: any;
};
const UserDetailsModel = ({ onClose, open, user }: Props) => {
  function calculateAge(birthdate: any) {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let ageYears = today.getFullYear() - birthDate.getFullYear();
    let ageMonths = today.getMonth() - birthDate.getMonth();

    // If the birthdate hasn't occurred yet this year
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      ageYears--;
      ageMonths += 12;
    }

    return { years: ageYears, months: ageMonths };
  }
  let tests = useSelector(test);
  const matchedUser = tests?.find((test: any) => test?.userId?._id === user?._id);

  const labels = ["E-commerce Store", "Vet Clinics", "Pet Supply Stores", "Pet Insurance", "Pet Televet"];
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        className="tw-mt-12"
      >
        <DialogTitle id="alert-dialog-title">
          <p className="tw-text-[#FF7B6D] tw-font-semibold">Name</p>
          <p className="tw-text-4xl tw-font-bold">{user?.fullName}</p>
          <div className="tw-w-full tw-border-b-2 mt-2"></div>
        </DialogTitle>
        <DialogContent>
          <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-2">
            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="tw-font-bold tw-text-lg">Email:</div>
              <div className="tw-text-gray-500 tw-mt-0.5">{user?.email}</div>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="tw-font-bold tw-text-lg">Activation Code:</div>
              <div className="tw-text-gray-500 tw-mt-0.5">{matchedUser?.kitId?.code}</div>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="tw-font-bold tw-text-lg">Phone Number:</div>
              <div className="tw-text-gray-500 tw-mt-0.5">{user?.phone}</div>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="tw-font-bold tw-text-lg">Address:</div>
              <div className="tw-text-gray-500 tw-mt-0.5">{user?.address}</div>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="tw-font-bold tw-text-lg">City:</div>
              <div className="tw-text-gray-500 tw-mt-0.5">{user?.city}</div>
            </div>

            {matchedUser &&
              matchedUser.kitId?.purchaseDetails &&
              Object.entries(matchedUser.kitId.purchaseDetails)
                .filter(([_, value]) => (value as { checked: boolean; reason: string })?.checked)
                .map(([key, value], index) => {
                  const typedValue = value as { checked: boolean; reason: string };
                  return (
                    <div key={key}>
                      <div className="tw-flex tw-gap-2 tw-items-center">
                        <div className="tw-font-bold tw-text-lg">{labels[index] || key}:</div>
                        <div className="tw-text-gray-500 tw-mt-0.5">{typedValue.reason || "No reason provided"}</div>
                      </div>
                    </div>
                  );
                })}
          </div>

          <div className="tw-w-full tw-flex tw-justify-end mt-4">
            <button
              onClick={onClose}
              className="tw-bg-[#FF7B6D] tw-text-white tw-px-5 tw-py-2 tw-rounded-md tw-ml-auto"
            >
              Close
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default UserDetailsModel;
